<template>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-4 col-lg-5 col-md-7">
        <div class="card z-index-0 mt-10">
          <div class="card-body">
            <soft-badge
              color="warning"
              variant="gradient"
              size="sm"
              @click="$emit('close')"
              class="cursor-pointer float-right"
            >
              {{ $t("global.close") }}
            </soft-badge>
            <p class="my-3 text-bold">{{ $t("teachers.createNewTeacher") }}</p>

            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <InputForm
                  v-model="formData.name"
                  :placeholder="$t('teachers.detail.teacherName')"
                  type="text"
                  :isRequired="true"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <InputForm
                  v-model="formData.email"
                  placeholder="Email"
                  type="text"
                  :isRequired="true"
                  @select-change="handleFirstSelectChange"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <InputForm
                  v-model="formData.mobile"
                  :placeholder="$t('teachers.mobile')"
                  type="text"
                  :isRequired="true"
                />
              </div>
              <div class="mb-3">
                <InputForm
                  v-model="formData.address"
                  :placeholder="$t('teachers.address')"
                  type="text"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <SelectFormCourse
                  @select="getSubcourses"
                  v-model="courses"
                  :isRequired="true"
                  :selectedOption="$t('courses.selectCourse')"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <SelectFormSubcourse
                  @select1="setSubcourse"
                  v-model="subcourses"
                  :isRequired="true"
                  :isDisabled="!subcourses.length"
                  :selectedOption="$t('subcourses.selectSubcourse')"
                />
              </div>
              <div class="mb-3">
                <DatePicker
                  v-model="formData.date"
                  :placeholder="$t('teachers.employedSinceDate')"
                  :isRequired="true"
                />
              </div>
              <div>
                <label
                  for="file"
                  :v-model="formData.file"
                  class="mx-2 custom-file-upload"
                >
                  <span>{{ $t("global.uploadImage") }}</span>
                </label>
                <input
                  type="file"
                  id="file"
                  @change="handleFileUpload"
                  accept="image/*"
                />
              </div>
              <div class="text-center">
                <soft-button
                  color="dark"
                  full-width
                  variant="gradient"
                  class="my-4 mb-2"
                >
                  {{ $t("global.create") }}
                </soft-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputForm from "@/components/InputForm.vue";
import SelectFormCourse from "@/components/SelectFormCourse.vue";
import SelectFormSubcourse from "@/components/SelectFormSubcourse.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import DatePicker from "@/components/DatePicker.vue";
import swal from "sweetalert2";

export default {
  name: "FormCreateTeacher",
  components: {
    InputForm,
    SelectFormCourse,
    SelectFormSubcourse,
    SoftButton,
    SoftBadge,
    DatePicker,
  },
  data() {
    return {
      formData: {
        name: "",
        email: "",
        mobile: "",
        address: "",
        subcourse: [],
        date: "",
      },
      courses: [],
      subcourses: [],
      selectedFile: "",
      selectedCourse: null,
      selectedSubcourse: null,
      isFirstSelected: false,
      imageUrl: "",
    };
  },
  created() {
    this.getCourses();
  },
  methods: {
    async submitForm(event) {
      event.preventDefault();
      const formData = new FormData();
      formData.append("name", this.formData.name);
      formData.append("email", this.formData.email);
      formData.append("mobile", this.formData.mobile);
      if (this.formData.date != "") {
        formData.append("employed_from", this.formData.date);
      }
      if (this.formData.address != "") {
        formData.append("address", this.formData.address);
      }
      formData.append("subcourse", this.formData.subcourse);
      if (this.selectedFile != "") {
        formData.append("image", this.selectedFile);
      }
      try {
        await axios.post("teacher", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.resetForm();
        swal.fire({
          icon: "success",
          title: this.$t("teachers.teacherCreated"),
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("form-submitted", true);
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          let errorMessages = "";

          if (typeof errors === "function") {
            for (const key in errors) {
              if (errors.prototype.hasOwnProperty.call(errors, key)) {
                errorMessages += `- ${errors[key].join(", ")}\n`;
                swal.fire({
                  title: this.$t("global.error"),
                  html: errorMessages.replace(/\n/g, "<br>"),
                  icon: "error",
                  position: "top-end",
                });
              }
            }
          } else {
            for (const key in errors) {
              errorMessages += `- ${errors[key].join(", ")}\n`;
              swal.fire({
                title: this.$t("global.error"),
                html: errorMessages.replace(/\n/g, "<br>"),
                icon: "error",
                position: "top-end",
              });
            }
          }
        }
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.selectedFile = file;

      // Kreiraj URL za prikazivanje pregleda slike
      this.imageUrl = URL.createObjectURL(file);
    },
    async getCourses() {
      const response = await axios.get("courses/all");
      this.courses = response.data.courses;
    },
    async getSubcourses(selectedCourse) {
      const response = await axios.get("subcourses/course/" + selectedCourse);
      this.subcourses = response.data.subcourses;
    },
    setSubcourse(selectedSubcource) {
      this.formData.subcourse = selectedSubcource;
    },
    handleFirstSelectChange(selectedValue) {
      this.isFirstSelected = !!selectedValue; // Proverava da li je vrednost izabrana
    },
    resetForm() {
      this.formData.name = "";
      this.formData.email = "";
      this.formData.mobile = "";
      this.formData.employed_from = "";
      this.formData.address = "";
      this.formData.subcourse = null;
      this.formData.date = "";

      return;
    },
  },
};
</script>

<style scoped>
.custom-file-upload {
  display: inline-block;
  padding: 10px 20px;
  cursor: pointer;
  background: linear-gradient(to right, #7fe02f, #2cb735);
  color: white;
  border-radius: 8px;
}
#file {
  display: none;
}
.custom-file-upload span {
  pointer-events: none;
}
.float-right {
  float: right;
}
</style>
